import React from 'react';
import {CardContent, CardMedia} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Trans} from "react-i18next";

function SelectedProductDesigns({cart}) {
    const filter = (items, key) => {
        return !((items[key]?.product?.necessaryDesigns && Number(items[key].product.necessaryDesigns) > 0) ||
            items[key]?.params?.hasOwnProperty('file'));
    }

    const getDesigns = () => {
        const items = cart?.items || {};
        return Object.keys(items).filter(key => filter(items, key)).map(key => {
            const item = items[key];

            return <Grid key={key} sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <CardMedia image={item.product.images[0].thumbnail || item.product.images[0].src}
                           sx={{
                               width: 82,
                               height: 82,
                               borderRadius: '50%',
                               border: '2px dashed',
                               borderColor: 'secondary.main',
                           }}/>
                x{item.nr}
            </Grid>
        });
    }

    const designs = getDesigns();
    return (designs.length ?
            <Box>
                <CardContent sx={{px: 0}}>
                    <Typography><Trans i18nKey={'designsPage.selectedDesigns'}/></Typography>
                </CardContent>
                <Grid container gap={1}>{designs}</Grid>
            </Box> : ''
    );
}

export default SelectedProductDesigns;
